import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

interface AppProps {
    trackingId: string;
}

const App = ({ trackingId } : AppProps) => (
    <div className="sid-verification-form">
        <div className="sid-headband__logo">
            <img src="./img/stellantis-logo.png" alt="singapore airlines logo" />
        </div>
        <VerificationForm programId={programId} trackingId={trackingId} />
    </div>
);

export default App;
